import React, { FC } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { TLatestNewsCardItemProps, TLatestNewsProps } from './types/latestNews.types';
import { LatestNewsModel } from './models/latestNews.model';
import NewsCard from './components/newsCard/index';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import RoutableSitecoreLink from '../@shared/routableSitecoreLink';
import DictionaryTerm from '../@shared/dictionaryTerm';
import Icon from '../@shared/icon';
import { iconSize } from '../../constants/icon.constants';
import { WithTranslation, withTranslation } from 'react-i18next';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';

const LatestNews: FC<TLatestNewsProps & WithTranslation> = (props) => {
  const model = new LatestNewsModel(props);
  const { t } = props;
  const latestNewsHeadingTitle = t('cnhi-news-latest-title');

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <AnalyticsVisibleEvent rendering={props.rendering} title={latestNewsHeadingTitle} template={'Latest News'} className="latest-news">
      <div className="latest-news__heading-wrapper">
        <div className="latest-news__heading-eyebrow">
          <DictionaryTerm keyword="cnhi-news-latest-eyebrow" />
        </div>

        <div className="latest-news__heading-text">
          <div className="latest-news__heading-title">{latestNewsHeadingTitle}</div>

          <RoutableSitecoreLink field={model?.link} className="latest-news__heading-link">
            <DictionaryTerm keyword="cnhi-showAll" />
            <Icon iconName="arrow-simple-right" size={iconSize.dsk} color={'primary'} extraClassName="cta-with-arrow__icon" />
          </RoutableSitecoreLink>
        </div>
      </div>

      <div className="latest-news__cards-wrapper">
        {model?.items?.map((item: TLatestNewsCardItemProps, index) => (
          <NewsCard
            item={item}
            key={model?.items?.length + index}
            cardHeadingTitleTag={model?.headingTag}
            sitecoreContext={props?.sitecoreContext}
            defaultCardImage={model?.defaultCardImageNarrow}
            readMoreKey={t('cnhi-readMore')}
            index={index}
            socialMediaBarProps={model.socialMediaBarProps}
          />
        ))}
      </div>
    </AnalyticsVisibleEvent>
  );
};

export default withTranslation()(withSitecoreContext()(LatestNews));
